import superagent from '@ott/superagent';
import TYPES from '../types';

function cancelOrderRequest(confirmationId) {
  return superagent
    .get('/_railways/rzd/cancelBooking')
    .query({
      confirmationId,
    })
    .withCredentials();
}

function cancelOrders(confirmationIds) {
  return async (dispatch) => {
    if (!confirmationIds || !confirmationIds.length) {
      return;
    }

    dispatch({
      type: TYPES.ORDER_CANCEL,
    });

    const requests = confirmationIds.map((confirmationId) => cancelOrderRequest(confirmationId));

    try {
      await Promise.all(requests);
    } catch (e) {}

    dispatch({
      type: TYPES.ORDER_CANCEL_SUCCESS,
    });
  };
}

export default cancelOrders;
